import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ProcessPage = lazy(() => import('../pages/process/page'));
const DestinationsPage = lazy(() => import('../pages/destinations/page'));
const TestimonialsPage = lazy(() => import('../pages/testimonials/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/a-propos',
    element: <AboutPage />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '/processus',
    element: <ProcessPage />
  },
  {
    path: '/destinations',
    element: <DestinationsPage />
  },
  {
    path: '/temoignages',
    element: <TestimonialsPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
